import apiClient from './client'
import type { Athlete, CreateAthleteRequest, UpdateAthleteRequest } from '@shared/types/api'

export const athletesApi = {
  // POST /api/v1/assistants/{assistantId}/athletes - создать спортсмена
  create: async (data: CreateAthleteRequest): Promise<Athlete> => {
    const response = await apiClient.post<Athlete>(
      `/assistants/${data.assistant_id}/athletes`,
      data
    )
    return response.data
  },

  // GET /api/v1/athletes/{id} - получить спортсмена
  getById: async (id: string): Promise<Athlete> => {
    const response = await apiClient.get<Athlete>(`/athletes/${id}`)
    return response.data
  },

  // GET /api/v1/assistants/{assistantId}/athletes - список спортсменов ассистента
  getByAssistantId: async (assistantId: string): Promise<Athlete[]> => {
    const response = await apiClient.get<Athlete[]>(`/assistants/${assistantId}/athletes`)
    return response.data
  },

  // GET /api/v1/groups/{groupId}/athletes - список спортсменов группы
  getByGroupId: async (groupId: string): Promise<Athlete[]> => {
    const response = await apiClient.get<Athlete[]>(`/groups/${groupId}/athletes`)
    return response.data
  },

  // POST /api/v1/assistants/{assistantId}/athletes/similar - возможные дубли по имени
  // (с уменьшительными: «Соколова Маша» - «Соколова Мария»). POST: имя ребёнка
  // не уходит в адрес и журналы доступа.
  findSimilar: async (assistantId: string, name: string): Promise<Athlete[]> => {
    const response = await apiClient.post<Athlete[]>(`/assistants/${assistantId}/athletes/similar`, { name })
    return response.data
  },

  // PUT /api/v1/athletes/{id} - обновить спортсмена
  update: async (id: string, data: UpdateAthleteRequest): Promise<Athlete> => {
    const response = await apiClient.put<Athlete>(`/athletes/${id}`, data)
    return response.data
  },

  // DELETE /api/v1/athletes/{id} - удалить спортсмена
  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/athletes/${id}`)
  },

  // GET /api/v1/assistants/{assistantId}/athletes/export - экспорт в CSV
  exportToCSV: async (assistantId: string): Promise<Blob> => {
    const response = await apiClient.get(`/assistants/${assistantId}/athletes/export`, {
      responseType: 'blob',
    })
    return response.data
  },

  // POST /api/v1/assistants/{assistantId}/athletes/import - импорт из файла с LLM
  importFromFile: async (
    assistantId: string,
    file: File,
    groupId?: string
  ): Promise<{ total_parsed: number; created: number; updated: number; failed: number; errors: string[] }> => {
    const formData = new FormData()
    formData.append('file', file)
    if (groupId) {
      formData.append('group_id', groupId)
    }

    // Не указываем Content-Type явно - axios автоматически установит multipart/form-data с boundary
    const response = await apiClient.post(
      `/assistants/${assistantId}/athletes/import`,
      formData
    )
    return response.data
  },
}
